module.exports = __webpack_public_path__ + "img/smoke1.f4d06c1d.png";